import React from "react";
import clsx from "clsx";
import "./snap-effect-container.styles.scss";

import { SNAP_EFFECT_CONTAINER_ID, SNAP_EFFECT_ID } from "../../../../constants";
import type { SnapEffectEventListener } from "./snap-effect-event-listener";
import type { GhostElementProps } from "./GhostElement";

import { IntId } from "../../../../utils/ids/int-id";
import snapEffectEventListener from "./snap-effect-event-listener";
import { GhostElement } from "./GhostElement";

const VISIBLITY_MARGIN = 50;
const INT_ID_GENERATOR = new IntId();

const BlockName = "snap-effect-container";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {},
} as const;

export interface SnapEffectContainerProps {}

type GhostElementState = Omit<GhostElementProps, "onAnimationEnd"> & {
	onComplete: () => void;
};

export type SnapEffectContainerComponent = React.FC<SnapEffectContainerProps> & {
	ClassNames: typeof ClassNames;
	EventListener: SnapEffectEventListener;
};

export const SnapEffectContainer = ((props: SnapEffectContainerProps) => {
	const containerRef = React.useRef<HTMLDivElement>(null);
	const [snapElements, setSnapElements] = React.useState<GhostElementState[]>([]);

	React.useEffect(() => {
		return SnapEffectContainer.EventListener.addListener(
			"animate-snap",
			(payload: { element: HTMLElement; onComplete: () => void }) => {
				const { element, onComplete } = payload;
				// Get element current fixed position on screen
				const rect = element.getBoundingClientRect();
				const x = rect.left + window.scrollX;
				const y = rect.top + window.scrollY;
				const width = rect.width;
				const height = rect.height;

				// Check for visibility
				if (
					x + width + VISIBLITY_MARGIN < 0 ||
					x - VISIBLITY_MARGIN > window.innerWidth ||
					y + height + VISIBLITY_MARGIN < 0 ||
					y - VISIBLITY_MARGIN > window.innerHeight
				) {
					return false;
				}

				const seed = Math.floor(Date.now() / 1000);
				const filterId = `${SNAP_EFFECT_ID}-${INT_ID_GENERATOR.next()}`;

				const ghostElement: GhostElementState = {
					domElement: element,
					width,
					height,
					x,
					y,
					seed,
					filterId,
					onComplete,
				};
				setSnapElements((prev) => [...prev, ghostElement]);
			},
		);
	}, []);
	return (
		<div
			ref={containerRef}
			id={SNAP_EFFECT_CONTAINER_ID}
			className={clsx(SnapEffectContainer.ClassNames.Block)}
		>
			{snapElements.map((ghostElement) => {
				return (
					<GhostElement
						key={ghostElement.filterId}
						{...ghostElement}
						onAnimationEnd={() => {
							setSnapElements((prev) =>
								prev.filter(
									(element) => element.filterId !== ghostElement.filterId,
								),
							);
							// ghostElement.onComplete();
						}}
					/>
				);
			})}
		</div>
	);
}) as SnapEffectContainerComponent;

SnapEffectContainer.ClassNames = ClassNames;
SnapEffectContainer.EventListener = snapEffectEventListener;
